export default {"trigger":"QyTXk","menuItem":"apKzO","manageSubsDialog":"F5AUD","buttonWrapper":"_6y-Ze","closeDialog":"eTmB8"};